import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { ArticleListItemType, BoardConfigType } from '../../@types/board'
import { getArticleList, getBoardConfiguration } from '../../api/board'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

// 이미지 경로
const imgURL = '/images'

export default function FaqList() {
  const [faqItem, setFaqItem] = useState<ArticleListItemType[]>([])
  const [page, setPage] = useState<number>(1)
  const [count, setCount] = useState<number[]>([])
  const [boardCon, setBoardCon] = useState<BoardConfigType[]>([])
  const [boardNo, setBoardNo] = useState<any>()
  const { setIsLottie } = useCommonContext()

  useEffect(() => {
    getBoardConfiguration().then((res) => {
      setBoardCon(res.data.boardConfigs)
    })
  }, [])

  useEffect(() => {
    if (boardCon) {
      const faqBoard = boardCon.find((el: any) => el.boardId === 'faq')
      if (faqBoard) {
        setBoardNo(faqBoard.boardNo)
      }
    }
  }, [boardCon])
  useEffect(() => {
    if (boardNo) {
      getArticleList(boardNo, page)
        .then((res) => {
          setFaqItem(res.data.items)
          const pageCount = Math.ceil(res.data.items.length / 10) === 0 ? 1 : Math.ceil(res.data.items.length / 10)
          for (let i = 0; i < pageCount; i++) {
            setCount((prev) => [...prev, i + 1])
          }
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    }
  }, [boardNo])

  useEffect(() => {
    if (page !== 1) {
      getArticleList(boardNo, page)
        .then((res) => {
          setFaqItem(res.data.items)
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    }
  }, [page, boardNo])

  // 자주 묻는 질문이 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap')
    faqItem?.length === 0 ? contentsWrap?.classList.add('full') : contentsWrap?.classList.remove('full')
  }, [])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>자주 묻는 질문</PageTitle>
            <div className='faq_list'>
              {faqItem.length === 0 ? (
                <NoContentWrap>
                  <NoContentCotentWrap2>
                    <img src='/images/empty_logo.png' alt='' />
                    <NoList>등록된 내용이 없습니다.</NoList>
                  </NoContentCotentWrap2>
                </NoContentWrap>
              ) : (
                <>
                  <ul>
                    {faqItem.map((el: any) => {
                      return <FaqItem item={el} key={el.articleNo} />
                    })}
                  </ul>
                  {/* 페이지네이션 */}
                  {count.length === 0 || count.length === 1 ? null : (
                    <div className='pagination'>
                      <button>
                        <img src={`${imgURL}/icon_arrow_prev.svg`} alt='' />
                      </button>
                      {count.map((el) => {
                        return (
                          <button
                            className={page === el ? 'on' : ''}
                            key={el}
                            onClick={() => {
                              setPage(el)
                              if (el !== 1) {
                                setIsLottie(true)
                              }
                            }}
                          >
                            {el}
                          </button>
                        )
                      })}
                      <button>
                        <img src={`${imgURL}/icon_arrow_next.svg`} alt='' />
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const FaqItem = ({ item }: any) => {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  return (
    <li>
      <Link
        to={`/FaqView/${item.articleNo}`}
        onClick={(event) => {
          event.preventDefault()
          if (isAppView) {
            RNPostMessage(AFWebLinkType.moveToLink, {
              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/FaqView/${item.articleNo}`,
            })
          } else {
            navigate(`/FaqView/${item.articleNo}`)
          }
        }}
      >
        <div>
          <div className='title'>{item.title}</div>
          <div className='date'>
            {item.registerYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
          </div>
        </div>
        <span>
          <img src={`${imgURL}/icon_arrow_right.svg`} alt='' />
        </span>
      </Link>
    </li>
  )
}
export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`
export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0 160px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`
export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoList = styled(NoContentContent)`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    margin-top: 0;
  }
`
